import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconNumberedListSvg } from "./IconNumberedListSvg.mjs";
const IconNumberedList = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconNumberedListSvg, ...svgProps }) });
export {
  IconNumberedList
};
